import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Box, Link as MuiLink, TextHeading } from '@ally/metronome-ui';
import { space } from 'styled-system';
import { StatusModalWireDetails } from './StatusModalWireData';
import { StatusModalAchDetails } from './StatusModalAchData';
import { StatusModalCheckDetails } from './StatusModalCheckData';
import { StatusModalDebitDetails } from './StatusModalDebitData';
const StyledTextHeading = styled(TextHeading)(space);
function getDetailsType(event) {
    switch (event.activityName) {
        case 'WireTransfer':
            return (React.createElement(StatusModalWireDetails, { event: event }));
        case 'CheckOrder':
            return (React.createElement(StatusModalCheckDetails, { event: event }));
        case 'DebitCardOrder':
            return (React.createElement(StatusModalDebitDetails, { event: event }));
        default:
            return (React.createElement(StatusModalAchDetails, { event: event }));
    }
}
const StatusModalDetails = ({ event, isStandaloneModal, isDebitCardEnabled }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledTextHeading, { tag: "h2", size: "xs", my: "md" }, "Details"),
        React.createElement(Box, null, getDetailsType(event)),
        isDebitCardEnabled && isStandaloneModal && (React.createElement(Box, { mb: "md", mt: "md" },
            React.createElement(MuiLink, { text: "Go to Status Tracker", variant: "outline" },
                React.createElement(Link, { to: "/status-tracker" }))))));
};
export default StatusModalDetails;
//# sourceMappingURL=StatusModalDetails.js.map